export enum DefinitionType {
  HarvesterHead = 1,
  MachineComputer = 2,
  MachineManufacturer = 3
}
